


































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { AutenticacaoRemotaUseCase, FindPerfilUseCase, FindUsuarioUseCase, LoginUseCase } from '@/usecases'
import { TokenJwt, Credenciais, Desconto, Perfil, ItemDaVenda, StatusDaAutenticacaoRemota, TipoDaAutenticacaoRemota } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TipoDeRegraDePermissao } from '@/models/RegraDeNegocio'
import { perfilTemRegraDeNegocio } from '@/shareds/permissoes-shareds'
import { VendaModule } from '@/store/vuex/venda/VendaStore'

function gerarCredenciais(): Credenciais {
	return {
		login: '',
		senha: '',
	}
}

@Component
export default class DialogoDeAutenticacao extends Vue {
	@Ref() formDialogoAutenticacao!: HTMLFormElement
	@Ref() campoDeLogin!: HTMLInputElement

	obrigatorio = obrigatorio

	carregando = false
	mostra = false
	mostraErro = false
	regra: TipoDeRegraDePermissao | null = null
	errorMessage = ''
	persistent = false
	validar = true
	autenticacaoPadrao = true
	desconto: Desconto | null = null
	itemDaVenda: ItemDaVenda | null = null
	solicitacaoRemotaId: string | null = null
	identificadorAuthRemotaId: string | null = null
	mostraModalRemoto = false
	carregandoRemoto = false
	statusRemoto: StatusDaAutenticacaoRemota | 'PENDENTE' = 'PENDENTE'
	cooldownSegundos = 0
	cooldownTimer: number | null = null
	ultimoCheckEmMs: number | null = null

	autenticacaoRemotaUseCase = new AutenticacaoRemotaUseCase()


	credenciais = gerarCredenciais()
	resolveDialogo: ((value: { autenticado: boolean; usuarioId?: string }) => void) | null = null

	get autenticacaoGeral() {
		return UserLoginStore.autenticando
	}

	async mostrar(
		lojaId?: string | undefined,
		regra?: TipoDeRegraDePermissao,
		desconto?: Desconto,
		item?: ItemDaVenda,
		persistent = false,
		validar = true,
		autenticacaoPadrao?: boolean,
	): Promise<{ autenticado: boolean; usuarioId?: string }> {
		this.desconto = desconto || null
		this.itemDaVenda = item || null
		
		if (regra && UserLoginStore.permiteRegraDeNegocio(regra) && !desconto) {
			return { 
				autenticado: true, 
				usuarioId: this.credenciais.usuarioIdLiberacaoVendaSemEstoque,
			}
		}
		
		this.mostra = true
		this.regra = regra || null
		this.persistent = persistent
		this.credenciais.lojaId = lojaId
		this.validar = validar
		
		this.autenticacaoPadrao = autenticacaoPadrao ?? true

		setTimeout(() => {
			this.campoDeLogin.focus()
			setTimeout(() => {
				this.formDialogoAutenticacao.resetValidation()
			})
		})
		
		return new Promise<{ autenticado: boolean; usuarioId?: string }>(resolve => {
			this.resolveDialogo = resolve
		})
	}

	@Watch('mostra')
	async onChangeMostra(mostra: boolean) {
		if (!mostra) {
			await this.cancelarSePendente()
			// Só resolve se ainda não foi resolvido (evita resolução dupla quando cancelandoAcao é chamado)
			if (this.resolveDialogo) {
				this.resolveDialogo({ autenticado: false })
				this.resolveDialogo = null
			}
			return
		}
		this.credenciais = {
			...this.credenciais,
			login: '',
			senha: '',
		}
	}

	cancelandoAcao() {
		if (this.resolveDialogo) {
			this.resolveDialogo({ autenticado: false })
			this.resolveDialogo = null
		}
		this.mostra = false
	}

	async autenticar(): Promise<void> {
		if (!this.formDialogoAutenticacao.validate()) return
		try {
			this.carregando = true
			const tokenJwt: TokenJwt = await new LoginUseCase().signIn(this.credenciais)
			if (!tokenJwt) throw new Error('Usuário ou senha inválidos')
			if (UserLoginStore.autenticando) await this.validarUsuarioLogado(tokenJwt)
			if (this.regra) await this.validarPermissaoDoLogin(tokenJwt, this.regra)
			if (this.resolveDialogo) {
				this.resolveDialogo({ autenticado: true, usuarioId: this.credenciais.usuarioId })
				this.resolveDialogo = null
			}
			this.mostra = false
			this.mostraErro = false
		} catch (error: any) {

			if(UserLoginStore.autenticando) {
				this.errorMessage = error.message;
				this.mostraErro = true
			} else AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async validarUsuarioLogado(tokenJwt: TokenJwt) {
		const usuarioLogado = await new FindUsuarioUseCase().usuarioLogado()
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		if (usuario.id !== usuarioLogado.id) throw new Error('Credenciais diferem do usuário já logado.')
	}

	async validarPermissaoDoLogin(tokenJwt: TokenJwt, regra: TipoDeRegraDePermissao) {
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		this.credenciais.usuarioId = usuario.id
		const perfil = await new FindPerfilUseCase().findById(usuario.perfil.id) || null

		if (!perfilTemRegraDeNegocio(perfil, regra)) throw new Error(`Usuário não tem permissão (${this.regra})`)

		this.itemDaVenda 
			? this.validarValorDescontoItemDaVenda(perfil, this.itemDaVenda)
			: this.validarValorDescontoCapaDaVenda(perfil)
	}

	validarValorDescontoItemDaVenda(perfil: Perfil, item: ItemDaVenda) {
		const venda = VendaModule.vendaAtual
		if (venda && this.desconto && this.desconto.valor > 0) {
			if(perfil.permissoes.includes('pode-conceder-desconto-por-item')) {
				if(item.possuiDescontoPorTabela) {
					const porcentagemDeDescontoDoItem = this.desconto.isPercentual
						? this.desconto.valor
						: (this.desconto.valor / item.preco) *100
					
					const percentualDeDescontoMaximo = Math.max(item.percentualDescontoTabelaPreco, perfil.percentualMaximoDescontoPorItem)

					if(porcentagemDeDescontoDoItem > percentualDeDescontoMaximo && venda.pagamentos.length < 1) {
						throw new Error(item.percentualDescontoTabelaPreco > perfil.percentualMaximoDescontoPorItem 
							? `O desconto aplicado neste item (${porcentagemDeDescontoDoItem.toFixed(2)}%) 
								excede o limite máximo permitido pela tabela de preço (${item.percentualDescontoTabelaPreco.toFixed(2)}%).`
							: `Este item tem um desconto de ${porcentagemDeDescontoDoItem.toFixed(2)}%, mas você só pode conceder até
								${perfil.percentualMaximoDescontoPorItem.toFixed(2)}% de desconto por item. Ajuste o valor do desconto para não exceder o limite permitido.`)
					}
				} else {
					const valorDeDescontoDoItem = item.possuiDescontoPorTabela ? 0 : this.desconto.valor
					const porcentagemDeDescontoDoItem = this.desconto.isPercentual
						? valorDeDescontoDoItem
						: (this.desconto.valor / item.preco) *100

					if(porcentagemDeDescontoDoItem > perfil.percentualMaximoDescontoPorItem && venda.pagamentos.length < 1) {
						throw new Error(`Este item tem um desconto de ${porcentagemDeDescontoDoItem.toFixed(2)}%, mas você só pode conceder até
						${perfil.percentualMaximoDescontoPorItem.toFixed(2)}% de desconto por item. Ajuste o valor do desconto para não exceder o limite permitido.`)
					}
				}
			} else {
				throw new Error('Usuário não tem permissão para conceder desconto por item')
			}
		}
	}

	validarValorDescontoCapaDaVenda(perfil: Perfil) {
		const venda = VendaModule.vendaAtual
		if (venda && this.desconto && this.desconto.valor > 0) {
			let valorTotalDeDescontoDosItens = 0;
			let valorBrutoDaVenda = 0;

			for(let i=0; venda.itens.length > i; i++) {
				const item = venda.itens[i]
				
				if(!item.possuiDescontoPorTabela && item.isCompra && this.desconto.valor > 0) {
					if(item.desconto.isPercentual) {
						const retiraValorDaPorcentagem = item.preco * (item.desconto.valor / 100);
						valorTotalDeDescontoDosItens = valorTotalDeDescontoDosItens + retiraValorDaPorcentagem;
					} else {
						valorTotalDeDescontoDosItens = valorTotalDeDescontoDosItens + item.desconto.valor;
					}
				}
				if(item.possuiDescontoPorTabela) {
					const descontoDaTabelaDePreco = (venda.itens[i].preco * (venda.itens[i].desconto.valor / 100))
					valorBrutoDaVenda = valorBrutoDaVenda + (venda.itens[i].preco - descontoDaTabelaDePreco)
				} else {
					valorBrutoDaVenda = valorBrutoDaVenda + (venda.itens[i].preco)
				}
			}

			const porcentagemDeDescontoDaCapa = this.desconto.isPercentual
				? this.desconto.valor
				: (this.desconto.valor / valorBrutoDaVenda) *100

			if (porcentagemDeDescontoDaCapa > perfil.percentualMaximoDesconto && venda.pagamentos.length < 1) {
				throw new Error(`O desconto aplicado é de ${porcentagemDeDescontoDaCapa.toFixed(2)}%, 
					mas o limite permitido para a capa da venda é de ${perfil.percentualMaximoDesconto.toFixed(2)}%`)
			}
		}
	}

	get permiteAutenticacaoRemotaDoPerfil() {
		return UserLoginStore.permiteRegraDeNegocio('permite-solicitar-autenticacao-remota')
	}

	async solicitarAutenticacaoRemota() {
		if (!this.regra) return
		try {
			this.carregandoRemoto = true

			const tipo = this.mapearTipoDaRegra(this.regra)
			const venda = VendaModule.vendaAtual
			const desconto = this.desconto

			let percentualDesconto = 0

			if (desconto && desconto.valor > 0) {
				if (this.itemDaVenda) {
					percentualDesconto = this.calcularPercentualDescontoDoItem(desconto, this.itemDaVenda)
				} else if (venda) {
					percentualDesconto = this.calcularPercentualDescontoDaCapa(desconto, venda)
				}
			}

			percentualDesconto = Number(percentualDesconto.toFixed(2))

			const payload = {
				tipo, 
				regraDePermissao: this.regra,
				valorDesconto: percentualDesconto,
			}

			const criada = await this.autenticacaoRemotaUseCase.criarAutenticacaoRemota(payload)
			this.solicitacaoRemotaId = criada.id
			this.statusRemoto = criada.status ?? 'PENDENTE'
			this.identificadorAuthRemotaId = criada.identificador

			this.mostraModalRemoto = true
			this.mostraErro = false 
		} catch (e: any) {
			AlertModule.setError('Não foi possível solicitar autenticação remota')
		} finally {
			this.carregandoRemoto = false
		}
	}

	async verificarStatusRemoto() {
		if (!this.solicitacaoRemotaId) return
		if (this.cooldownSegundos > 0) return
		this.iniciarCooldown(15)

		try {
			this.carregandoRemoto = true
			const auth = await this.autenticacaoRemotaUseCase.findById(this.solicitacaoRemotaId)

			this.statusRemoto = auth.status

			if (auth.status === 'Liberado') {
				this.limparCooldown()
				if (this.resolveDialogo) {
					this.resolveDialogo({
						autenticado: true,
					})
					this.resolveDialogo = null
				}

				this.mostraModalRemoto = false
				this.mostra = false
				return
			}

			if (auth.status === 'Negado' || auth.status === 'Cancelado') {
				this.limparCooldown()
				this.errorMessage = auth.status === 'Negado'
					? 'Solicitação negada.'
					: 'Solicitação cancelada.'
				AlertModule.setError(this.errorMessage)
				this.mostraModalRemoto = false
				
			}
		} catch (e: any) {
			AlertModule.setError('Não foi possível verificar o status')
		} finally {
			this.carregandoRemoto = false
		}
	}

	async cancelarSolicitacaoRemota() {
		if (!this.solicitacaoRemotaId) return
		await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(this.solicitacaoRemotaId, 'Cancelado')
		this.limparCooldown()
		AlertModule.setSuccess("Solicitação remota cancelada!")
		this.mostraModalRemoto = false
	}

	mapearTipoDaRegra(regra: TipoDeRegraDePermissao): TipoDaAutenticacaoRemota {
		switch (regra) {
			case 'pode-liberar-venda-fora-do-estado':
				return 'Fiscal'
			default:
				return 'Financeiro'
		}
	}

	@Watch('mostraModalRemoto')
	async onChangeMostraModalRemoto(aberto: boolean) {
		if (!aberto) {
			await this.cancelarSePendente()
		}
	}

	private async cancelarSePendente() {
		if (!this.solicitacaoRemotaId) return
		if (this.statusRemoto !== 'Pendente') return

		try {
			await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(this.solicitacaoRemotaId, 'Cancelado')
		} catch(error: any) {
			AlertModule.setError("Não foi possível atualizar o status da autenticação remota.")
		} finally {
			this.solicitacaoRemotaId = null
			this.statusRemoto = 'Pendente'
			this.limparCooldown()
		}
	}

	async beforeDestroy() {
		await this.cancelarSePendente()
	}

	iniciarCooldown(segundos = 15) {
		this.cooldownSegundos = segundos
		this.ultimoCheckEmMs = Date.now()

		if (this.cooldownTimer) {
			window.clearInterval(this.cooldownTimer)
		}

		this.cooldownTimer = window.setInterval(() => {
			this.cooldownSegundos = Math.max(0, this.cooldownSegundos - 1)

			if (this.cooldownSegundos === 0 && this.cooldownTimer) {
				window.clearInterval(this.cooldownTimer)
				this.cooldownTimer = null
			}
		}, 1000)
	}

	limparCooldown() {
		this.cooldownSegundos = 0
		this.ultimoCheckEmMs = null
		if (this.cooldownTimer) {
			window.clearInterval(this.cooldownTimer)
			this.cooldownTimer = null
		}
	}

	calcularPercentualDescontoDoItem(desconto: Desconto, item: ItemDaVenda): number {
		if (!desconto || desconto.valor <= 0) return 0
		const base = item.preco || 0
		if (base <= 0) return 0

		return desconto.isPercentual ? desconto.valor : (desconto.valor / base) * 100
	}

	calcularValorBrutoDaVenda(venda: any): number {
		let valorBruto = 0

		for (const item of venda.itens) {
			if (item.possuiDescontoPorTabela) {
				const descontoTabela = item.preco * (item.desconto.valor / 100)
				valorBruto += (item.preco - descontoTabela)
			} else {
				valorBruto += item.preco
			}
		}

		return valorBruto
	}

	calcularPercentualDescontoDaCapa(desconto: Desconto, venda: any): number {
		if (!desconto || desconto.valor <= 0) return 0
		const bruto = this.calcularValorBrutoDaVenda(venda)
		if (bruto <= 0) return 0

		return desconto.isPercentual ? desconto.valor : (desconto.valor / bruto) * 100
	}

}
